<div class="dialog-container">
  <h1>Edit Driver</h1>

  <form class="form-container" [formGroup]="editDriverProfileForm">
    <mat-form-field appearance="outline">
      <mat-label>First Name</mat-label>
      <input id="editDriverProfileDialog-text-firstName" matInput placeholder="First Name" formControlName="firstName" data-private="lipsum" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Middle Name</mat-label>
      <input id="editDriverProfileDialog-text-middleName" matInput placeholder="Middle Name" formControlName="middleName" data-private="lipsum" />
    </mat-form-field>

    <mat-checkbox id="editDriverProfileDialog-checkbox-driverHasNoMiddleName" color="primary" formControlName="hasNoMiddleName">Driver does not have a middle name</mat-checkbox>

    <mat-form-field appearance="outline">
      <mat-label>Last Name</mat-label>
      <input id="editDriverProfileDialog-text-lastName" matInput placeholder="Last Name" formControlName="lastName" data-private="lipsum" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input id="editDriverProfileDialog-text-email" matInput placeholder="Email" formControlName="email" disable />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Phone Number</mat-label>
      <input id="editDriverProfileDialog-text-phone" matInput uzPhoneNumberInput placeholder="Phone" formControlName="phoneNumber" disable />
    </mat-form-field>

    <mat-form-field appearance="outline" class="street-address">
      <mat-label>Street Address</mat-label>
      <input id="editDriverProfileDialog-text-streetAddress" matInput placeholder="Street Address" formControlName="streetAddressOne" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="street-address">
      <mat-label>Apt, suite, etc (optional)</mat-label>
      <input id="editDriverProfileDialog-text-streetAddressTwo" matInput placeholder="Apt, suite, etc" formControlName="streetAddressTwo" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>City</mat-label>
      <input id="editDriverProfileDialog-text-city" matInput placeholder="City" formControlName="city" />
    </mat-form-field>

    <div class="state-and-zipcode-wrapper">
      <mat-form-field appearance="outline" class="state">
        <mat-label>State</mat-label>
        <mat-select id="editDriverProfileDialog-select-state" formControlName="state">
          <mat-option *ngFor="let state of states" [value]="state.code">
            {{ state.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Zip Code</mat-label>
        <input id="editDriverProfileDialog-text-zipCode" matInput placeholder="Zip Code" formControlName="zipCode" type="number" appZipcode />
      </mat-form-field>
    </div>

    <div mat-dialog-actions align="end" class="action-buttons">
      <button id="editDriverProfileDialog-button-cancel" mat-button type="button" color="primary" (click)="handleCancelButtonClick()">Cancel</button>
      <button id="editDriverProfileDialog-button-save" mat-raised-button type="button" color="primary" (click)="handleSave()" [disabled]="editDriverProfileForm.invalid">
        Save
      </button>
    </div>
  </form>
</div>
